export const tabs = [
  { value: "positions", title: "Positions Configuration" },
  { value: "bom", title: "BMs" },
  { value: "approvalLimit", title: "Approval Limits" },
];

export const toList = (payload: any) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  return [];
};